<script setup lang="ts">
import { computed, defineProps } from "vue";

const props = defineProps({
  text: {
    type: String,
    required: true
  },
  color: {
    type: String,
    default: "#0027AF" // text color
  },
  bgColor: {
    type: String,
    default: "#E0E7FF" // background color
  },
  width: {
    type: String,
    default: "auto" // can be 'auto', 'full', or specific px/rem
  },
  icon: {
    type: String, // MDI class string or SVG string
    default: ""
  },
  image: {
    type: String, // optional image URL
    default: ""
  }
});

// Computed width for styling
const computedWidth = computed(() => {
  if (props.width === "full") return "100%";
  if (props.width === "auto") return "auto";
  return props.width;
});
</script>

<template>
  <div
    :style="{
      display: 'flex',
      alignItems: 'center',
      gap: props.icon || props.image ? '6px' : '0',
      width: computedWidth,
      backgroundColor: props.bgColor,
      color: props.color,
      borderRadius: '14px',
      padding: '4px 8px',
      cursor: 'default',
      marginBottom: '21px'
    }"
  >
    <!-- Image -->
    <img v-if="props.image" :src="props.image" :alt="''" style="width: 20px; height: 20px;" />

    <!-- MDI Icon / SVG -->
    <span v-else-if="props.icon" v-html="props.icon" aria-hidden="true"  style="display: flex; font-size: 20px;"></span>

    <small>{{ props.text }}</small>
  </div>
</template>
